// Standards Registry — catálogo completo de normas e frameworks suportados
// status: "locked" (base SGI, sempre ativo), "available" (toggle on/off), "planned" (sem dados)
// loaded: true  → norma com base normativa completa no sistema
// loaded: false → módulo futuro / dados parciais
//
// Sempre que possível, `loaded` é resolvido a partir de src/data/normsManifest.json
// (gerado por `node scripts/scan-normas.js`). Se o manifesto não existir ou não
// contiver o short, é mantido o valor hardcoded.

// Vite resolve este JSON no build; se o arquivo não existir, o script de scan
// (`node scripts/scan-normas.js`) deve ser executado antes para criá-lo.
import NORMS_MANIFEST from "../../data/normsManifest.json";

export const NORMS_MANIFEST_DATA = NORMS_MANIFEST;

function resolveLoaded(short, fallback) {
  const matched = NORMS_MANIFEST?.summary?.matchedISOs;
  if (!matched) return fallback;
  if (matched.includes(short)) return true;
  return fallback;
}

const RAW_REGISTRY = [
  // SGI CORE — base do sistema integrado
  { id: "iso9000",  name: "ABNT NBR ISO 9000:2015",  short: "9000",  category: "Infraestrutura", status: "locked", loaded: true,  color: "#7c4dff",  dataFile: "standards/iso9000_2015.json", desc: "Sistemas de gestão da qualidade — Fundamentos e vocabulário" },
  { id: "iso9001",  name: "ABNT NBR ISO 9001:2015",  short: "9001",  category: "SGI", status: "available", loaded: true,  color: "#ef5350",  dataFile: "standards/iso9001_2015.json", desc: "Sistemas de gestão da qualidade — Requisitos", defaultOn: true },
  { id: "iso14001", name: "ABNT NBR ISO 14001:2015", short: "14001", category: "SGI", status: "available", loaded: true,  color: "#4caf50",  dataFile: "standards/iso14001_2015.json", desc: "Sistemas de gestão ambiental — Requisitos com orientações para uso", defaultOn: true },
  { id: "iso45001", name: "ABNT NBR ISO 45001:2018", short: "45001", category: "SGI", status: "available", loaded: true,  color: "#ffa726",  dataFile: "standards/iso45001_2018.json", desc: "Sistemas de gestão da segurança e saúde ocupacional — Requisitos com orientações para uso", defaultOn: true },
  // AUDITORIA — locked (sempre ativa, inteligência do NORM)
  { id: "iso19011", name: "ABNT NBR ISO 19011:2018", short: "19011", category: "Infraestrutura", status: "locked", loaded: true,  color: "#9171f8",  dataFile: "standards/iso19011_2018.json", desc: "Diretrizes para auditoria de sistemas de gestão" },
  // CERTIFICAÇÃO — organismos de certificação (OAC)
  { id: "iso17021", name: "ABNT NBR ISO/IEC 17021-1:2016", short: "17021", category: "Infraestrutura", status: "available", loaded: true,  color: "#5c6bc0",  dataFile: "standards/iso17021_2016.json", desc: "Requisitos para organismos que fornecem auditoria e certificação de sistemas de gestão" },
  // GOVERNANÇA E COMPLIANCE
  { id: "iso37000", name: "ABNT NBR ISO 37000:2022", short: "37000", category: "Governança",  status: "available", loaded: true,  color: "#8d6e63",  dataFile: "standards/iso37000_2022.json", desc: "Governança de organizações — Orientações" },
  { id: "iso37001", name: "ABNT NBR ISO 37001:2017", short: "37001", category: "Compliance",  status: "available", loaded: true,  color: "#ab47bc",  dataFile: "standards/iso37001_2017.json", desc: "Sistemas de gestão antissuborno — Requisitos com orientações para uso" },
  { id: "iso37301", name: "ABNT NBR ISO 37301:2021", short: "37301", category: "Compliance",  status: "available", loaded: true,  color: "#7e57c2",  dataFile: "standards/iso37301_2021.json", desc: "Sistemas de gestão de compliance — Requisitos com orientações para uso" },
  // RISCOS
  { id: "iso31000", name: "ABNT NBR ISO 31000:2009", short: "31000", category: "Riscos", status: "available", loaded: true,  color: "#ffa726",  dataFile: null, desc: "Gestão de riscos — Princípios e diretrizes" },
  { id: "iso31010", name: "ABNT NBR ISO/IEC 31010:2012", short: "31010", category: "Riscos", status: "available", loaded: true,  color: "#ff7043",  dataFile: null, desc: "Gestão de riscos — Técnicas para o processo de avaliação de riscos" },
  // RESPONSABILIDADE SOCIAL
  { id: "iso26000", name: "ABNT NBR ISO 26000:2010", short: "26000", category: "Social", status: "available", loaded: true,  color: "#26a69a",  dataFile: null, desc: "Diretrizes sobre responsabilidade social" },
];

export const STANDARDS_REGISTRY = RAW_REGISTRY.map(s => ({
  ...s,
  loaded: resolveLoaded(s.short, s.loaded),
}));

// Helper functions
export function getActiveStandards(toggleState) {
  return STANDARDS_REGISTRY.filter(s =>
    s.status === "locked" ||
    (s.status === "available" && (toggleState[s.id] === true || (s.defaultOn && toggleState[s.id] !== false)))
  );
}

export function getLockedStandards() {
  return STANDARDS_REGISTRY.filter(s => s.status === "locked");
}

export function getAvailableStandards() {
  return STANDARDS_REGISTRY.filter(s => s.status === "available");
}

export function getPlannedStandards() {
  return STANDARDS_REGISTRY.filter(s => s.status === "planned");
}

export function getLoadedStandards() {
  return STANDARDS_REGISTRY.filter(s => s.loaded === true);
}

export function getStandardById(id) {
  return STANDARDS_REGISTRY.find(s => s.id === id);
}
